import { useQuery } from '@tanstack/react-query';
import type { CountryDto, DepartmentDto, ExporterLookupDto, UserLookupDto } from '@mexp/shared';
import { http } from '@/api/client';

export function useDepartments(includeInactive = false) {
  return useQuery({
    queryKey: ['departments', includeInactive],
    queryFn: () => http.get<{ items: DepartmentDto[] }>('/departments', { includeInactive }),
    staleTime: 5 * 60_000,
    select: (d) => d.items,
  });
}

export function useExporterLookup(enabled = true) {
  return useQuery({
    queryKey: ['exporters', 'lookup'],
    queryFn: () => http.get<{ items: ExporterLookupDto[] }>('/exporters/lookup'),
    staleTime: 60_000,
    enabled,
    select: (d) => d.items,
  });
}

export function useCountries() {
  return useQuery({
    queryKey: ['countries'],
    queryFn: () => http.get<{ items: CountryDto[] }>('/countries'),
    staleTime: 10 * 60_000,
    select: (d) => d.items,
  });
}

export function useStaffLookup(params: { department?: string | null; role?: string } = {}, enabled = true) {
  return useQuery({
    queryKey: ['users', 'lookup', params.department ?? null, params.role ?? null],
    queryFn: () => http.get<{ items: UserLookupDto[] }>('/users/lookup', { department: params.department ?? undefined, role: params.role }),
    staleTime: 60_000,
    enabled,
    select: (d) => d.items,
  });
}

export function departmentName(departments: DepartmentDto[] | undefined, code: string | null | undefined): string {
  if (!code) return '—';
  return departments?.find((d) => d.code === code)?.name ?? code;
}
